module.exports = __webpack_public_path__ + "img/wechat.e6ee62ce.png";